import "../scss/PrivacyPolicy.scss";
import { useMobile } from "../hooks/useMobile";
import MobileHeader from "../components/MobileHeader";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
  const isMobile = useMobile();

  return (
    <>
      <section className="policy">
        {isMobile ? <MobileHeader /> : <Header />}
        <div className="policy__container">
          <h1 className="policy__title">
            Политика конфиденциальности и обработки персональных данных
          </h1>

          <p className="policy__date">Дата публикации: 05.12.2025</p>

          <div className="policy__text">
            <p>
              Настоящая Политика конфиденциальности (далее — Политика)
              определяет порядок обработки и защиты персональных данных
              физических лиц, которые посещают сайт по адресу:&nbsp;
              <a
                href="https://rightshift.dev/"
                target="_blank"
                rel="noreferrer"
              >
                https://rightshift.dev/
              </a>
              &nbsp;(далее — Сайт) и/или используют формы обратной связи и иные
              функциональные возможности Сайта.
            </p>

            <p>
              Политика разработана в соответствии с законодательством Российской
              Федерации, в том числе с Федеральным законом от 27.07.2006 №
              152-ФЗ «О персональных данных», а также иными применимыми
              нормативными правовыми актами Российской Федерации в области
              персональных данных.
            </p>

            <p>
              Используя Сайт, вы выражаете своё согласие с условиями настоящей
              Политики.
            </p>

            <p>
              <strong>1. Оператор персональных данных</strong>
            </p>

            <p>
              1.1. Оператором персональных данных (далее — Оператор) является:
              <br />
              Индивидуальный предприниматель Абреков Габриэль Геннадьевич
              <br />
              ИНН: 771482689526
              <br />
              ОГРНИП: 324265100143942
            </p>

            <p>
              1.2. Контактные данные Оператора:
              <br />
              Сайт:&nbsp;
              <a
                href="https://rightshift.dev/"
                target="_blank"
                rel="noreferrer"
              >
                https://rightshift.dev/
              </a>
              <br />
              Электронная почта:&nbsp;
              <a href="mailto:info@rightshift.dev">info@rightshift.dev</a>
              <br />
              Телефон: +7 967 222-00-78
            </p>

            <p>
              1.3. Настоящая Политика распространяется на все персональные
              данные, которые Оператор может получить о пользователях Сайта
              (далее — Пользователи).
            </p>

            <p>
              <strong>2. Термины и определения</strong>
            </p>

            <p>
              2.1. <strong>Персональные данные</strong> — любая информация,
              относящаяся прямо или косвенно к определённому или определяемому
              физическому лицу (Пользователю).
            </p>

            <p>
              2.2. <strong>Обработка персональных данных</strong> — любое
              действие (операция) или совокупность действий (операций),
              совершаемых с использованием средств автоматизации или без их
              использования с персональными данными, включая сбор, запись,
              систематизацию, накопление, хранение, уточнение (обновление,
              изменение), извлечение, использование, передачу (распространение,
              предоставление, доступ), обезличивание, блокирование, удаление,
              уничтожение персональных данных.
            </p>

            <p>
              2.3. <strong>Пользователь Сайта (Пользователь)</strong> — любое
              физическое лицо, посещающее Сайт и/или использующее его функционал
              (включая отправку форм).
            </p>

            <p>
              2.4. <strong>Cookies (куки-файлы)</strong> — небольшие фрагменты
              данных, отправляемые веб-сервером и сохраняемые на устройстве
              Пользователя, которые веб-клиент или веб-браузер пересылает
              веб-серверу в HTTP-запросе при попытке открыть страницу Сайта.
            </p>

            <p>
              2.5.{" "}
              <strong>Автоматизированная обработка персональных данных</strong>{" "}
              — обработка персональных данных с помощью средств вычислительной
              техники.
            </p>

            <p>
              2.6. Все иные термины используются в значении, предусмотренном
              действующим законодательством Российской Федерации.
            </p>

            <p>
              <strong>
                3. Объём и категории обрабатываемых персональных данных
              </strong>
            </p>

            <p>
              3.1. Оператор обрабатывает следующие категории персональных данных
              Пользователя, предоставленных им самостоятельно посредством форм
              на Сайте:
              <br />
              — имя (или указанный Пользователем псевдоним/название контактного
              лица);
              <br />
              — контактные данные:
              <br />
              номер телефона;
              <br />
              контакт для связи в мессенджере (в том числе Telegram), если
              указан;
              <br />
              адрес электронной почты (e-mail).
            </p>

            <p>
              3.2. При использовании Сайта также автоматически могут
              обрабатываться данные технического характера:
              <br />
              — IP-адрес Пользователя;
              <br />
              — данные о браузере (тип, версия, язык);
              <br />
              — данные об используемом устройстве и операционной системе;
              <br />
              — дата и время доступа к Сайту;
              <br />
              — адрес запрашиваемой страницы;
              <br />
              — источник перехода на Сайт (реферер);
              <br />
              — файлы Cookies (куки-файлы);
              <br />— обезличенные данные о действиях Пользователя на Сайте
              (посещённые страницы, пролистывания, клики и т.п.), в том числе в
              рамках работы систем аналитики.
            </p>

            <p>
              3.3. Оператор <strong>не обрабатывает</strong> и целенаправленно
              не запрашивает особые категории персональных данных (данные о
              состоянии здоровья, политических взглядах, религиозных убеждениях,
              интимной жизни, национальной принадлежности и т.п.), а также
              данные, отнесённые к биометрическим.
            </p>

            <p>
              3.4. Оператор не осуществляет обработку платёжных данных
              Пользователя (банковские карты и т.п.) через Сайт.
            </p>

            <p>
              3.5. Оператор не осуществляет целенаправленную обработку
              персональных данных детей и лиц младше 18 лет. Сайт не
              ориентирован на несовершеннолетних и не содержит функционала,
              специально предназначенного для них.
            </p>

            <p>
              <strong>4. Источники получения персональных данных</strong>
            </p>

            <p>
              4.1. Персональные данные предоставляются Пользователем добровольно
              путём:
              <br />
              — заполнения и отправки форм на Сайте (например, формы «Обсудить
              проект» или иных форм обратной связи);
              <br />— самостоятельного обращения к Оператору по указанным на
              Сайте контактным данным (по e-mail, телефону, через мессенджеры и
              т.п.).
            </p>

            <p>
              4.2. Технические данные (включая IP-адрес, Cookies и информацию об
              устройстве) собираются автоматически при посещении Сайта, в том
              числе с использованием систем веб-аналитики.
            </p>

            <p>
              <strong>5. Цели обработки персональных данных</strong>
            </p>

            <p>
              Оператор обрабатывает персональные данные Пользователей
              исключительно для следующих целей:
            </p>

            <p>
              5.1. <strong>Связь с Пользователем и обработка обращений</strong>
              <br />
              — обработка заявок и запросов, отправленных через формы на Сайте;
              <br />
              — обратная связь с Пользователем (ответы на вопросы, консультации
              по услугам, уточнение деталей проекта и т.п.);
              <br />— организация взаимодействия по вопросам заключения и
              исполнения договоров.
            </p>

            <p>
              5.2.{" "}
              <strong>
                Заключение и исполнение договоров и иных соглашений
              </strong>
              <br />
              — подготовка и заключение договоров на оказание услуг Оператора
              (разработка сайтов и ПО, дизайн, маркетинг и другие услуги
              web-студии);
              <br />— ведение документооборота и выполнение обязательств
              Оператора перед Пользователями и заказчиками.
            </p>

            <p>
              5.3.{" "}
              <strong>
                Информационное взаимодействие и сервисные коммуникации
              </strong>
              <br />
              — направление уведомлений, связанных с обработкой заявок и
              исполнением договоров;
              <br />— при необходимости — информирование о статусе проекта,
              сроках, изменениях условий и иных важных моментах взаимодействия.
            </p>

            <p>
              5.4.{" "}
              <strong>Аналитика, улучшение работы Сайта и маркетинг</strong>
              <br />
              — анализ посещаемости и поведения Пользователей на Сайте;
              <br />
              — улучшение структуры, контента и функционала Сайта, оптимизация
              интерфейсов и сценариев взаимодействия;
              <br />
              — ведение обезличенной статистики по работе Сайта;
              <br />— организация маркетинговой аналитики в рамках
              законодательно допустимых методов.
            </p>

            <p>
              Персональные данные <strong>не используются</strong> для принятия
              решений, основанных исключительно на автоматизированной обработке,
              которые имеют юридические последствия для Пользователя или иным
              образом существенно на него влияют.
            </p>

            <p>
              <strong>
                6. Правовые основания обработки персональных данных
              </strong>
            </p>

            <p>
              6.1. Оператор осуществляет обработку персональных данных на
              следующих правовых основаниях:
              <br />
              — согласие Пользователя на обработку его персональных данных,
              выраженное путём совершения соответствующих действий на Сайте (см.
              раздел 8 настоящей Политики);
              <br />
              — необходимость обработки персональных данных для заключения и/или
              исполнения договора, стороной или выгодоприобретателем по которому
              является Пользователь;
              <br />— необходимость выполнения Оператором обязанностей,
              установленных законодательством Российской Федерации.
            </p>

            <p>
              6.2. Отправляя форму на Сайте и/или обращаясь к Оператору по
              указанным контактам, Пользователь подтверждает, что:
              <br />
              — ознакомлен с условиями настоящей Политики;
              <br />— даёт согласие на обработку своих персональных данных в
              объёме и на условиях, предусмотренных Политикой.
            </p>

            <p>
              <strong>7. Cookies и системы аналитики</strong>
            </p>

            <p>
              7.1. При посещении Сайта на устройстве Пользователя могут
              сохраняться Cookies. Они используются Оператором для:
              <br />
              — обеспечения корректной работы Сайта;
              <br />
              — улучшения качества функционирования Сайта;
              <br />— проведения статистических и аналитических исследований.
            </p>

            <p>
              7.2. Пользователь может в любой момент изменить настройки
              обработки Cookies в параметрах своего браузера (блокировать или
              ограничить использование Cookies). Однако это может повлиять на
              корректность работы отдельных функций Сайта.
            </p>

            <p>
              7.3. На Сайте используются системы аналитики третьих лиц, в том
              числе:
              <br />
              Яндекс.Метрика — сервис веб-аналитики, позволяющий получать
              обезличенные статистические данные о посещениях Сайта и поведении
              Пользователей.
            </p>

            <p>
              7.4. Данные, собираемые такими сервисами, предоставляются
              Оператору в обезличенном виде и используются для анализа и
              улучшения работы Сайта. При этом такие сервисы могут
              самостоятельно обрабатывать персональные данные в соответствии со
              своими правилами и политиками конфиденциальности.
            </p>

            <p>
              7.5. Обработка данных в Яндекс.Метрике осуществляется в
              соответствии с политикой конфиденциальности ООО «Яндекс».
              Пользователь вправе самостоятельно ознакомиться с условиями
              обработки данных такими третьими лицами на их официальных
              ресурсах.
            </p>

            <p>
              7.6. Оператор не несёт ответственности за обработку персональных
              данных третьими лицами в рамках их собственных сервисов, однако
              предпринимает разумные меры по выбору надёжных партнёров и
              сервисов.
            </p>

            <p>
              <strong>8. Порядок получения согласия</strong>
            </p>

            <p>
              8.1. Согласие Пользователя на обработку его персональных данных
              считается предоставленным в следующих случаях:
              <br />
              — при нажатии на кнопку «Обсудить проект» или любую иную кнопку
              отправки формы на Сайте, сопровождаемую текстом о согласии с
              Политикой конфиденциальности и (или) ссылкой на неё;
              <br />
              — при направлении Оператору письменного, электронного или иного
              обращения, содержащего персональные данные, с использованием
              указанных на Сайте контактных данных;
              <br />— при продолжении использования Сайта после отображения
              уведомления о Cookies (в части обработки данных, связанных с
              Cookies и аналитикой).
            </p>

            <p>
              8.2. Согласие предоставляется Пользователем на срок,
              соответствующий сроку хранения персональных данных, установленному
              настоящей Политикой, и может быть отозвано Пользователем в
              порядке, предусмотренном разделом 12.
            </p>

            <p>
              <strong>
                9. Условия и порядок обработки персональных данных
              </strong>
            </p>

            <p>
              9.1. Обработка персональных данных осуществляется Оператором с
              использованием средств автоматизации и (или) без использования
              таких средств в соответствии с требованиями действующего
              законодательства Российской Федерации.
            </p>

            <p>
              9.2. Оператор осуществляет обработку персональных данных с
              соблюдением следующих принципов:
              <br />
              — законность целей и способов обработки;
              <br />
              — добросовестность;
              <br />
              — соответствие объёма и характера обрабатываемых персональных
              данных заявленным целям обработки;
              <br />— недопустимость объединения баз данных, которые были
              созданы для несовместимых целей.
            </p>

            <p>
              9.3. Персональные данные не подлежат распространению или раскрытию
              третьим лицам без согласия Пользователя, за исключением случаев,
              прямо предусмотренных законодательством Российской Федерации.
            </p>

            <p>
              9.4. Обработка персональных данных Пользователя не предусматривает
              их передачу за пределы Российской Федерации.
            </p>

            <p>
              9.5. Оператор <strong>не передаёт</strong> персональные данные
              Пользователя иным лицам для целей их самостоятельного маркетинга,
              рекламных рассылок или иных действий, выходящих за рамки целей,
              указанных в разделе 5 настоящей Политики.
            </p>

            <p>
              <strong>10. Хранение и защита персональных данных</strong>
            </p>

            <p>
              10.1. Персональные данные Пользователей хранятся на защищённых
              серверах, размещённых на территории Российской Федерации.
            </p>

            <p>
              10.2. Оператор принимает необходимые и достаточные организационные
              и технические меры для защиты персональных данных от:
              <br />
              — неправомерного или случайного доступа;
              <br />
              — уничтожения, изменения, блокирования, копирования,
              предоставления, распространения;
              <br />— иных неправомерных действий третьих лиц.
            </p>

            <p>
              10.3. К числу применяемых Оператором мер относятся:
              <br />
              — использование защищённых серверов и актуальных программных
              средств;
              <br />
              — ограничение доступа к персональным данным, предоставление
              доступа только лицу (лицам), уполномоченному(ым) Оператором и
              обязанному(ым) сохранять конфиденциальность таких данных;
              <br />
              — использование средств защиты информации, включая шифрование (где
              применимо);
              <br />— резервное копирование данных (где необходимо) и контроль
              целостности.
            </p>

            <p>
              10.4. Доступ к персональным данным Пользователей имеют только
              Оператор и уполномоченные представители ИП Абрекова Г.Г., для
              которых такая информация необходима для выполнения служебных
              (должностных) обязанностей.
            </p>

            <p>
              <strong>11. Сроки хранения персональных данных</strong>
            </p>

            <p>
              11.1. Персональные данные хранятся Оператором в течение срока,
              необходимого для достижения целей обработки, указанных в настоящей
              Политике, если иной срок хранения не установлен законодательством
              Российской Федерации или соглашениями с Пользователем.
            </p>

            <p>
              11.2. Срок хранения может быть продлён в случаях, когда это
              необходимо для:
              <br />
              — исполнения обязательств по заключённым договорам;
              <br />
              — соблюдения требований законодательства Российской Федерации;
              <br />— защиты прав и законных интересов Оператора.
            </p>

            <p>
              11.3. По достижении целей обработки персональных данных и/или при
              наступлении обстоятельств, требующих прекращения обработки (в том
              числе при отзыве согласия Пользователя), персональные данные
              подлежат уничтожению или обезличиванию, если их дальнейшее
              хранение не требуется в соответствии с законодательством
              Российской Федерации.
            </p>

            <p>
              <strong>
                12. Права Пользователя как субъекта персональных данных
              </strong>
            </p>

            <p>
              12.1. Пользователь имеет право:
              <br />
              — получать информацию, касающуюся обработки его персональных
              данных, в предусмотренном законом порядке;
              <br />
              — требовать уточнения своих персональных данных, их блокирования
              или уничтожения, если персональные данные являются неполными,
              устаревшими, неточными, незаконно полученными или не являются
              необходимыми для заявленной цели обработки;
              <br />
              — отозвать своё согласие на обработку персональных данных,
              направив Оператору соответствующее обращение;
              <br />
              — требовать устранения неправомерных действий Оператора в
              отношении его персональных данных;
              <br />— обжаловать действия или бездействие Оператора в
              уполномоченный орган по защите прав субъектов персональных данных
              и (или) в судебном порядке.
            </p>

            <p>
              12.2. Для реализации своих прав Пользователь может направить
              обращение Оператору:
              <br />— по электронной почте:&nbsp;
              <a href="mailto:info@rightshift.dev">info@rightshift.dev</a>;
              <br />— либо иным способом, указанным на Сайте.
            </p>

            <p>
              12.3. В обращении рекомендуется указать:
              <br />
              — ФИО или иные идентификационные данные;
              <br />
              — суть запроса или требования;
              <br />— контактные данные для ответа.
            </p>

            <p>
              12.4. Оператор рассматривает обращения Пользователей в разумные
              сроки и в порядке, предусмотренном законодательством Российской
              Федерации.
            </p>

            <p>
              <strong>
                13. Порядок отзыва согласия на обработку персональных данных
              </strong>
            </p>

            <p>
              13.1. Пользователь вправе в любой момент отозвать своё согласие на
              обработку персональных данных, направив Оператору письменное или
              электронное обращение по указанным в настоящей Политике контактным
              данным.
            </p>

            <p>
              13.2. После получения уведомления об отзыве согласия Оператор
              прекращает обработку персональных данных Пользователя, за
              исключением случаев, когда обработка необходима для:
              <br />
              — достижения целей, предусмотренных международным договором
              Российской Федерации или законом;
              <br />
              — осуществления и выполнения функций, полномочий и обязанностей
              Оператора;
              <br />
              — исполнения договора, стороной которого является Пользователь, до
              его полного исполнения;
              <br />— хранения персональных данных в течение сроков,
              установленных законодательством Российской Федерации.
            </p>

            <p>
              13.3. В случае отзыва согласия отдельные сервисы и функциональные
              возможности Сайта могут стать недоступными для Пользователя.
            </p>

            <p>
              <strong>
                14. Ответственность сторон и ограничение ответственности
              </strong>
            </p>

            <p>
              14.1. Оператор несёт ответственность за соблюдение требований
              законодательства Российской Федерации в области обработки и защиты
              персональных данных.
            </p>

            <p>
              14.2. В случае нарушения Оператором порядка обработки персональных
              данных Пользователь вправе обратиться с жалобой в уполномоченный
              орган по защите прав субъектов персональных данных и (или) в суд.
            </p>

            <p>
              14.3. Оператор не несёт ответственность за:
              <br />
              — предоставление Пользователем недостоверных или неполных данных;
              <br />
              — последствия, связанные с использованием третьими лицами
              общедоступной информации, размещённой Пользователем самостоятельно
              в открытых источниках;
              <br />— действия третьих лиц, если утечка или иное нарушение
              конфиденциальности данных произошло по их вине (например, по вине
              операторов связи, провайдеров хостинга, систем аналитики, включая
              Яндекс.Метрику, либо в результате неправомерных действий
              злоумышленников).
            </p>

            <p>
              14.4. В случае, если нарушение конфиденциальности или безопасности
              персональных данных произошло в результате действий (бездействия)
              третьих лиц, а не Оператора, ответственность за такие действия
              несут указанные третьи лица в соответствии с законодательством
              Российской Федерации.
            </p>

            <p>
              <strong>15. Изменение Политики конфиденциальности</strong>
            </p>

            <p>
              15.1. Оператор вправе вносить изменения в настоящую Политику в
              одностороннем порядке.
            </p>

            <p>
              15.2. Актуальная версия Политики постоянно доступна на Сайте по
              соответствующей ссылке.
            </p>

            <p>
              15.3. В случае внесения изменений в Политику дата последнего
              обновления указывается в её начале.
            </p>

            <p>
              15.4. При существенных изменениях условий обработки персональных
              данных Оператор может разместить дополнительное уведомление на
              Сайте и/или иным образом проинформировать Пользователей.
            </p>

            <p>
              15.5. Продолжение использования Сайта после вступления в силу
              новой редакции Политики означает согласие Пользователя с её
              условиями.
            </p>

            <p>
              <strong>16. Заключительные положения</strong>
            </p>

            <p>
              16.1. Настоящая Политика применяется исключительно к Сайту&nbsp;
              <a
                href="https://rightshift.dev/"
                target="_blank"
                rel="noreferrer"
              >
                https://rightshift.dev/
              </a>
              &nbsp;и не регулирует порядок обработки персональных данных на
              других сайтах, на которые Пользователь может перейти по ссылкам с
              Сайта.
            </p>

            <p>
              16.2. Во всём, что не урегулировано настоящей Политикой, Оператор
              и Пользователь руководствуются действующим законодательством
              Российской Федерации.
            </p>

            <p>
              16.3. Настоящая Политика вступает в силу с 05.12.2025 и действует
              до её отмены или замены новой редакцией.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
